import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GroupStorage } from "../../models/auto-generated";
import { SettingsService } from "../../services/settings.service";
import { IS_SAAS } from "@coso/utility";

@Injectable()
export class GroupStorageGuard implements CanActivate {
  constructor(private router: Router,  @Inject(IS_SAAS) private isSaaS: boolean, private settingsService: SettingsService) {}
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    
    const id = route.paramMap.get("instance-id");
    const groupStorage = route.data.groupStorage as GroupStorage;    
    return this.settingsService.get(id).pipe(
      map((data) => {
        if (data.groupStorage === groupStorage || data.allowLoadDistributedSharePointConnections) {
          return true;
        }
        
        const errorMessage = "Cannot navigate to the requested page because the configuration is incorrect or incomplete. Please modify the group storage to SharePoint or set AllowLoadDistributedSharePointConnections to true. Please make sure you save it.";
        this.router.navigate(["/", "error"], { queryParams: { detail: errorMessage } });
        return false;
      })
    );
  }
}
